import styled from "styled-components";
import SocialBtn from "/public/assets/images/company/social/social-desc.png"
import {useContext, useEffect, useRef, useState} from "react";
import {LayoutContext} from "@/app/ClientRootHomepage";
import {getScroller, refreshOnAssetsReady, setupLenyStyle} from "@/app/homepage/utils";
import gsap from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
import WhyVisualBg from "/public/assets/images/company/social/why-visual.png"
import ImgItem01 from "/public/assets/images/company/social/item01.png"
import ImgItem02 from "/public/assets/images/company/social/item02.png"
import ImgItem03 from "/public/assets/images/company/social/item03.png"
import ImgItem04 from "/public/assets/images/company/social/item04.png"
import ImgItem05 from "/public/assets/images/company/social/item05.png"
import ImgItmMo05 from "/public/assets/images/company/social/item-mo-05.png"
import {SOCIAL_SLIDE_ITEMS} from "@/app/homepage/company/controller";
import CustomSwiper from "@/components/common/CustomSwiper";
import SlideNextIco from "/public/assets/icons/sld-next.png"
import SlidePrevIco from "/public/assets/icons/sld-prev.png"
import {SIZES} from "@/components/constants";
import {useMediaQuery} from "react-responsive";

gsap.registerPlugin(ScrollTrigger);

const SocialContribution = () => {
    const wrapRef = useRef(null);
    const { rootRef } = useContext(LayoutContext);
    const isTablet = useMediaQuery({
        query: `(max-width: ${SIZES.TABLET})`
    });
    const [whereSlideIdx, setWhereSlideIdx] = useState(0);
    useEffect(() => {
        const wrap = wrapRef.current;
        if (!wrap) return;
        const scroller = getScroller(rootRef);
        const contentEl =
            scroller?.querySelector?.(".root") ||
            scroller?.firstElementChild ||
            scroller;

        const { cleanup } = setupLenyStyle({ wrap, scroller, contentEl });
        const triggers = [];
        const timelines = [];

        const wraps = Array.from(wrap.querySelectorAll(".section-area .section-list"));
        wraps.forEach((w) => {
            const title = w.querySelector(".section-title");
            const cont = w.querySelector(".section-content");
            if (!cont) return;

            if (title) gsap.set(title, { opacity: 0 });
            gsap.set(cont, { y: 30, opacity: 0 });

            const tl = gsap
                .timeline({ paused: true })
                .to(
                    title || {},
                    {
                        opacity: 1,
                        duration: 0.4,
                        ease: "power1.out",
                        force3D: false,
                    },
                    0
                )
                .to(
                    cont,
                    {
                        y: 0,
                        opacity: 1,
                        duration: 0.6,
                        ease: "power2.out",
                        force3D: false,
                    },
                    0
                );

            const st = ScrollTrigger.create({
                trigger: cont,
                start: "top 75%",
                end: "top 45%",
                toggleActions: "play none none reverse",
                onEnter: () => tl.play(),
                onEnterBack: () => tl.play(),
                onLeaveBack: () => tl.reverse(),
            });

            timelines.push(tl);
            triggers.push(st);
        });

        const onResize = () => ScrollTrigger.refresh();
        window.addEventListener("resize", onResize);
        const offAssets = refreshOnAssetsReady(wrap, () => {
            ScrollTrigger.refresh();
        });

        return () => {
            triggers.forEach((st) => st.kill());
            timelines.forEach((tl) => tl.kill());
            window.removeEventListener("resize", onResize);
            offAssets && offAssets();
            cleanup();
        };
    }, [rootRef]);

    const setSlideClickFunc = (idx) => {
        setWhereSlideIdx(idx)
    }
    return(
        <SocialWrap ref={wrapRef}>
            <div className={"social-btn-area"}>
                <div className={"social-btn-wrap"}>
                    <div className={"social-btn-inner"}>
                        <img src={SocialBtn?.src} alt={"사회공헌 투게더 버튼"}/>
                    </div>
                </div>
            </div>
            <div className={"section-area"}>
                <div className={"section-list"}>
                    <div className={"section-title"}>1. Why?</div>
                    <WhyContent className={"section-content"}>
                        {
                            !isTablet &&
                            <div className={"cont-visual"}><img src={WhyVisualBg?.src} alt={"사회 환원 배경"}/></div>
                        }

                        <div className={"text-box"}>
                            <p>
                                {
                                   !isTablet  ?
                                        <>1) 미래를 위한 나눔, 미래 성장의 사다리 제공</>
                                        :
                                        <>1) 미래를 위한 나눔,<br/>미래 성장의 사다리 제공</>
                                }

                            </p>
                            <span>
                                경제적 어려움 속에 있는 저소득층 자녀 중 다수는 깨진 가정, 낮은 교육 접근성 등으로 인해 건강하게 성장하는데 어려움이 많습니다. 우리는 이들이 자신감과 자기 존중감을 갖고 스스로 공부하는 습관을 키울 수 있다면, 장차 가난의 대물림을 끊고 계층 이동을 이루어낼 수 있다고 믿습니다. 우리는 이들에게 미래 성장 사다리를 놓아주는 것에 투자한다는 사회공헌의 의미를 담고 있습니다.
                            </span>
                            {
                                isTablet &&
                                <div className={"img-item"}><img src={ImgItem01?.src} alt={"사회 환원 배경 아이템1"}/></div>
                            }
                        </div>
                        <div className={"text-box"}>
                            <p>
                                {
                                    !isTablet ?
                                        <>2) 사회 환원</>
                                        :
                                        <>2) 가치 실현 </>
                                }
                            </p>
                            <span>
                                웅비메디텍의 “웅비는 사회에 공헌하는 하나님의 기업”의 사명을 실천하는 비투게더 (BeeTogether) 프로젝트입니다. 고객이 주신 수익의 일부를 사회에 환원함으로써, 웅비메디텍은 생명과학을 기반으로 한 바이오-진단제품 공급자로서 선진 기술을 넘어 사람과 사회를 위한 가치 실현을 하고자 합니다.
                            </span>
                            {
                                isTablet &&
                                <div className={"img-item"}><img src={ImgItem02?.src} alt={"사회 환원 배경 아이템2"}/></div>
                            }
                        </div>
                        <div className={"text-box"}>
                            <p>3) 지속 동반 성장</p>
                            <span>웅비메디텍은 “지속 동반 성장”이라는 사명을 비사업분야에도 “비투게더edu”를 통해 지속 가능한 사회 성장 변화에 기여하고자 합니다.</span>
                        </div>
                        {
                            !isTablet &&
                            <div className={"sub-img-list"}>
                                <div className={"img-item"}><img src={ImgItem01?.src} alt={"사회 환원 배경 아이템1"}/></div>
                                <div className={"img-item"}><img src={ImgItem02?.src} alt={"사회 환원 배경 아이템2"}/></div>
                            </div>
                        }
                    </WhyContent>
                </div>
                <div className={"section-list"}>
                    <div className={"section-title"}>2. What?</div>
                    <WhatContent className={"section-content"}>
                        <div className={"list"}>
                        <div className={"info"}>
                                <p>지원 실적</p>
                                <span>12차-총 659명</span>
                            </div>
                            <div className={"desc fd-column jc-center start"}>
                                <p>2017년부터 시작하여 코로나 판데믹 기간에도 계속 지원, 2025년 상반기까지 12차례에 걸쳐 659명 청소년에게 공부방(학습공간)을 제공해 왔습니다.</p>
                                <div className={"tag-list"}>
                                    <div className={"item"}>경기도 이천</div>
                                    <div className={"item"}>경기도 광주</div>
                                    <div className={"item"}>경기도 여주</div>
                                    <div className={"item"}>경기도 안산</div>
                                </div>
                            </div>
                        </div>
                        <div className={"list"}>
                            <div className={"info"}>
                                <p>지원 대상</p>
                                <span>저소득층 다문화 가정의 청소년</span>
                            </div>
                            <div className={"desc"}>
                                <div className={"img-text-wrap"}>
                                    <p>저소득층과 다문화 가정의 청소년을 대상으로 지원 신청을 받아 서류심사를 거쳐 1회에 50-60명 수준에서 지원대상을 선발합니다.</p>
                                    <div className={"img-list"}>
                                        <div className={"img-item"}>
                                            <img src={ImgItem03?.src} alt={"광주시장 표창"} />
                                            <div className={"img-info"}>2023년 <span>광주시장 표창</span></div>
                                        </div>
                                        <div className={"img-item"}>
                                            <img src={ImgItem04?.src} alt={"이천시장 표창"}/>
                                            <div className={"img-info"}>2024년 <span>이천시장 표창</span></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className={"list"}>
                            <div className={"info"}>
                                <p>지원 물품</p>
                                <span>공부방 개설 맞춤형 학습 환경</span>
                            </div>
                            <div className={"desc"}>
                                <p>선발된 청소년들에게 학습공간인 공부방을 만들어 줍니다. 책상, 의자, 책꽂이, 독서대, 조명, 게시판 등을 제공하여 아이 한 명, 한 명을 위한 맞춤형 학습 환경을 만들어 줍니다.</p>
                            </div>
                        </div>
                    </WhatContent>
                </div>
                <div className={"section-list"}>
                    <div className={"section-title"}>3. Where?</div>
                    <WhereContent className={"section-content"}>
                        {
                            !isTablet &&
                            <div className={"where-sld-wrap"}>
                                <div className={"where-sld-view"}>
                                    {
                                        SOCIAL_SLIDE_ITEMS[whereSlideIdx].imageItem &&
                                        <img src={SOCIAL_SLIDE_ITEMS[whereSlideIdx].imageItem} alt={"Where 대표 이미지"}/>
                                    }
                                </div>
                                <div className={"where-sld-inner"}>
                                    <CustomSwiper
                                        slides={SOCIAL_SLIDE_ITEMS}
                                        effect="slide"
                                        spaceBetween={16}
                                        slideButton={true}
                                        slideOnclick={setSlideClickFunc}
                                        currentSlideIdx={whereSlideIdx}
                                        slidesPerView={"4.5"}
                                    />
                                </div>
                            </div>
                        }
                        <div className={"text-box"}>
                            <p>1) 대상 지역</p>
                            <span>대표이사의 고향인 경기도 이천시를 시작으로 경기도 광주시, 여주시, 안산시까지 지역을 확장했습니다.</span>
                            {
                                isTablet &&
                                <>
                                    <div className={"where-sld-view"}>
                                        {
                                            SOCIAL_SLIDE_ITEMS[whereSlideIdx].imageItem &&
                                            <img src={SOCIAL_SLIDE_ITEMS[whereSlideIdx].imageItem}
                                                 alt={"Where 대표 이미지"}/>
                                        }
                                    </div>
                                    <div className={"where-sld-inner"}>
                                        <CustomSwiper
                                            slides={SOCIAL_SLIDE_ITEMS}
                                            effect="slide"
                                            spaceBetween={16}
                                            slideButton={true}
                                            slideOnclick={setSlideClickFunc}
                                            currentSlideIdx={whereSlideIdx}
                                            slidesPerView={"1.2"}
                                        />
                                    </div>
                                </>
                            }
                        </div>
                        <div className={"text-box"}>
                            <p>2) 문화 활동</p>
                            <span>
                                매회 지원자 대상을 초청=&gt; JOB WORLD에서 직업 체험=&gt; 대형 서점 방문=&gt; 1인당 책 3권 구입=&gt; 회사로 이동=&gt; 회사 투어=&gt; 교육실=&gt; 독서의 중요성/생명의 소중함 강의=&gt; 귀가 (처음부터 귀가 시까지 웅비 직원들이 자원봉사자로 1:2 이끌어 줌)
                            </span>

                        </div>
                    </WhereContent>
                </div>
                <div className={"section-list"}>
                    <div className={"section-title"}>4. Purpose</div>
                    <PurposeContent className={"section-content"}>
                        {
                            !isTablet &&
                            <div className={"img-item-wrap"}>
                                <img src={ImgItem05?.src} alt={"작은 공부방에서 변화 이미지 pc"}/>
                            </div>
                        }
                        <div className={"text-box"}>
                            <p>1) "작은 공부방에서 시작되는 큰 변화"</p>
                            <span>
                                저소득층 및 다문화 가정의 자녀들의 방 한 켠에 공부방을 마련해 줌으로써, 혼자만의 집중 공간이 생기고 자기만의 공간을 만들어 주어 떨어진 자존감을 회복할 수 있도록 도와줍니다. 정서적 안정을 바탕으로 스스로 할 수 있는 자기 주도적인 학습 습관을 형성시켜줄 것입니다.
                            </span>
                            {
                                isTablet &&
                                <div className={"img-item-wrap"}>
                                    <img src={ImgItmMo05?.src} alt={"작은 공부방에서 변화 이미지 mo"}/>
                                </div>
                            }
                        </div>
                        <div className={"text-box"}>
                            <p>2) 건강한 사회 구성원</p>
                            <span>
                                이들은 부모가 저소득층이고 결손 가정이 많기 때문에 제대로 성장하기 어려운 환경에 처해 있습니다.  비행청소년이 되거나 성인이 되어 가난을 대물림할 가능성이 많습니다. 이들에게 희망과 자신감을 심어주고, 스스로 공부하는 습관을 길러준다면, 이들이 성인이 되어 군 복무, 출산, 취업, 가족 형성 등 한국 사회의 중추적 역할을 할 소중한 구성원이 될 것입니다.
                            </span>
                        </div>
                        <div className={"text-box"}>
                            <p>3) 사회 계층 이동</p>
                            <span>
                                공부방을 통해 청소년기에 형성된 자기 존중, 성실성과 학습 태도는 성인이 되었을 때 가난의 대물림을 끊을 수 있는 큰 힘이 됩니다. 이들이 건강하게 성장하여 경제활동을 통해 가난의 대물림을 끊고 중산층으로 이동할 수 있는 희망과 기회를 잡을 수 있게 될 것입니다.
                            </span>
                        </div>
                    </PurposeContent>
                </div>
                <div className={"section-list"}>
                    <div className={"section-title"}>
                        5. 지금은 환경,<br/>
                        다음은 습관
                    </div>
                    <div className={"section-content"}>
                        <div className={"normal-text"}>
                            현재는 학습 공간을 제공하는 데 집중하고 있지만, 앞으로는 그 공간 안에서 지속적으로 자기주도 학습 습관을 형성할 수 있는 프로그램도 함께 제공할 계획입니다.
                            이는 단순한 일회성 지원이 아닌, 청소년의 성장이 지속 가능한 방법을 찾아 시도하는 나눔을 의미합니다.
                        </div>
                    </div>
                </div>
                <div className={"section-list"}>
                    <div className={"section-title"}>6. 웅비인의 믿음</div>
                    <div className={"section-content"}>
                        <div className={"trust-wrap"}>
                            <p>“작은 공부방 하나가, 아이 한 명의 미래를 바꾸고, 대한민국의 내일을 더 좋게 만들어 갑니다.”</p>
                            <span>
                                웅비메디텍은 사람과 미래에 투자합니다. 비투게더edu 프로젝트를 통해 저소득층 및 다문화 가정의 청소년들에게 자기주도의 단단한 성장 사다리를 놓아주며, 함께 성장하는 더 나은 세상을 만들어가기 위해 노력하며 보람을 쌓아가고 있습니다.
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </SocialWrap>
    )
}
const PurposeContent = styled.div`
    .text-box{
        margin-top: 24px;
        p{
            margin-bottom: 24px;
            font-weight: 700;
            font-size: 24px;
            line-height: 36px;
            letter-spacing: -0.02em;
            color: #4939B1;
        }
        span{
            font-weight: 400;
            font-size: 20px;
            line-height: 32px;
            color: #000000;
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        .text-box{
            margin-top: 0;
            & + .text-box{
                margin-top: 40px;
            }
            p{
                margin-bottom: 16px;
                font-weight: 700;
                font-size: 24px;
                line-height: 36px;
            }
            span{
                font-weight: 400;
                font-size: 16px;
                line-height: 24px;
            }
            .img-item-wrap{
                margin-top: 16px;
            }
        }
    }
`
const WhereContent = styled.div`
    .where-sld-wrap{
        .where-sld-view{
            height: 725px;
            margin-bottom: 16px;
            img{
                width: 100%;
                height: 100%;
                object-fit: cover;
            }
        }
        .where-sld-inner{
            position: relative;
            .swiper{
                margin: 0 100px;
                .swiper-slide{
                    cursor: pointer;
                    border: 1px solid transparent;
                    height: 86px;
                    .image-wrap{
                        width: 100%;
                        height: 100%;
                        img{
                            width: 100%;
                            height: 100%;
                            object-fit: cover;
                        }
                    }
                    &.active{
                        border-color: #7566D0;
                    }
                }
            }
        }
    }

    .slide-buttons{
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 50px;
        .nav-btn{
            background-repeat: no-repeat;
            background-position: center;
            background-size: 30px 30px;
            width: 30px;
            text-indent: -9999px;
            &.prev{
                background-image: url(${SlidePrevIco?.src});

            }
            &.next{
                background-image: url(${SlideNextIco?.src});
            }
        }
    }
    .text-box{
        margin-top: 24px;
        p{
            font-weight: 700;
            font-size: 24px;
            line-height: 36px;
            letter-spacing: -0.02em;
            color: #4939B1;
            margin-bottom: 8px;
        }
        span{
            font-weight: 400;
            font-size: 20px;
            line-height: 32px;
            color: #000000;
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        .text-box{
            margin-top: 0;
            & + .text-box{
                margin-top: 40px;
            }
            p{
                margin-bottom: 16px;
                font-weight: 700;
                font-size: 24px;
                line-height: 36px;
                letter-spacing: -0.02em;
            }
            span{
                font-weight: 400;
                font-size: 16px;
                line-height: 24px;
            }
            .where-sld-view{
                margin-top: 16px;
                height: 320px;
                img{
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }
            
            .where-sld-inner{
                margin-top: 16px;
                .swiper{
                    width: calc(100% - 64px);
                    margin: 0 auto;
                    .swiper-slide{
                        height: 160px;
                        .image-wrap{
                            width: 100%;
                            height: 100%;
                            img{
                                width: 100%;
                                height: 100%;
                                object-fit: cover;
                            }
                        }
                    }
                }
            }
        }
        .slide-buttons{
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 0;
            .nav-btn{
                background-size: 24px 24px;
                width: 24px;
            }
        }
    }
`
const WhatContent = styled.div`
    .list{
        & + .list{
            margin-top: 40px;
        }
        display: flex;
        align-items: center;
        gap: 24px;
        height: 150px;
        .info{
            width: 340px;
            height: 100%;
            flex-shrink: 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            background: #F3F2F9;
            border-radius: 20px;
            gap: 8px;
            p{
                font-weight: 500;
                font-size: 18px;
                line-height: 28px;
                letter-spacing: -0.02em;
                color: #4939B1;
            }
            span{
                font-weight: 700;
                font-size: 24px;
                line-height: 36px;
                letter-spacing: -0.02em;
                color: #000000;
            }
        }
        .desc{
            height: 100%;
            display: flex;
            align-items: center;
            &.start{
                align-items: start;
            }
            p{
                font-weight: 400;
                font-size: 18px;
                line-height: 28px;
                color: #000000;
            }
            .tag-list{
                margin-top: 8px;
                display: flex;
                align-items: center;
                gap: 8px;
                .item{
                    width: 96px;
                    height: 30px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border: 1px solid #EBE9F4;
                    border-radius: 99px;
                    font-weight: 700;
                    font-size: 14px;
                    color: #666666;
                }
            }
            .img-text-wrap{
                display: flex;
                align-items: center;
                .img-list{
                    margin-left: 24px;
                    display: flex;
                    align-items: center;
                    .img-item{
                        .img-info{
                            font-weight: 400;
                            font-size: 14px;
                            line-height: 22px;
                            text-align: center;
                            color: #666666;
                            span{
                                font-weight: 600;
                            }
                        }
                    }
                }   
            }
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        .list{
            flex-direction: column;
            height: auto;
            gap: 16px;
            .info{
                width: 100%;
                height: 110px;
                p{
                    font-size: 16px;
                    line-height: 24px;
                    letter-spacing: -0.02em;
                }
                span{
                    font-size: 20px;
                    line-height: 30px;
                    letter-spacing: -0.02em;
                }
            }
            .desc{
                p{           
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 24px;
                }
                .tag-list{
                    .item{
                        width: 79px;
                        height: 26px;
                        font-size: 12px;
                    }
                }
                .img-text-wrap{
                    flex-direction: column;
                    .img-list{
                        margin: 24px 0 0;
                        .img-item{
                            .img-info{
                                font-size: 12px;
                                line-height: 18px;
                            }
                        }
                    }
                }
            }
        }
    }
`
const WhyContent = styled.div`
    .text-box{
        margin-top: 24px;
        p{
            font-weight: 700;
            font-size: 24px;
            line-height: 36px;
            letter-spacing: -0.02em;
            color: #4939B1;
        }
        span{
            font-weight: 400;
            font-size: 20px;
            line-height: 32px;
            color: #000000;
            margin-top: 8px;
        }
    }
    .sub-img-list{
        display: flex;
        gap: 24px;
        margin-top: 24px;
        padding-right: 190px;
    }
    @media (max-width: ${SIZES.TABLET}) {
        .text-box{
            margin: 0;
            & + .text-box{
                margin-top: 40px;
            }
            p{
                font-size: 24px;
                line-height: 36px;
                letter-spacing: -0.02em;
            }
            span{
                font-size: 16px;
                line-height: 24px;
                margin-top: 16px;
                display: block;
            }
            .img-item{
                margin-top: 16px;
            }
        }
    }
`
const SocialWrap = styled.div`
    .social-btn-area {
        width: 100%;
        display: flex;
        justify-content: center;

        .social-btn-wrap{
            width: 213px;
            height: 48px;
            background: #4939B1;
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            .social-btn-inner{
                width: 150px;
            }
        }
    }
    .section-area{
        padding: 160px 114px;
    }
    .section-list{
        & + .section-list{
            margin-top: 160px;
        }
        display: flex;
        align-items: start;
        .section-title{
            flex-shrink: 0;
            width: 400px;
            font-weight: 700;
            font-size: 48px;
            line-height: 58px;
            letter-spacing: -0.02em;
            color: #23203B;
        }
        .section-content{
            flex: 1 1 0;
            min-width: 0;
            .normal-text{
                font-weight: 400;
                font-size: 20px;
                line-height: 32px;
                color: #000000;
            }
            .trust-wrap{
                p{
                    font-weight: 700;
                    font-size: 24px;
                    line-height: 38px;
                    color: #000000;
                    margin-bottom: 16px;
                }
                span{
                    font-weight: 400;
                    font-size: 20px;
                    line-height: 32px;
                    color: #000000;
                }
            }
        }
    }
    @media (max-width: ${SIZES.TABLET}) {
        .social-btn-area {
            width: 100%;
            display: flex;
            justify-content: center;

            .social-btn-wrap{
                width: 213px;
                height: 48px;
                background: #4939B1;
                border-radius: 10px;
                display: flex;
                align-items: center;
                justify-content: center;
                .social-btn-inner{
                    width: 150px;
                }
            }
        }
        .section-area{
            padding: 80px 16px 120px;
        }
        .section-list{
            & + .section-list{
                margin-top: 80px;
            }
            flex-direction: column;
            gap: 40px;
            .section-title{
                width: 100%;
                font-size: 32px;
                line-height: 40px;
                letter-spacing: -0.02em;
            }
            .section-content{
                flex: 0;
                width: 100%;
                .normal-text{
                    font-weight: 400;
                    font-size: 16px;
                    line-height: 24px;
                    color: #000000;
                }
                .trust-wrap{
                    p{
                        font-size: 18px;
                        line-height: 28px;
                        margin-bottom: 10px;
                    }
                    span{
                        font-size: 16px;
                        line-height: 24px;
                    }
                }
            }
        }
    }
`
export default SocialContribution;